import Vue from 'vue'
import '@/services/weblog'
import App from './App.vue'
import router from './router'
import store from './store'
import '@kdocs/kdesign-theme/default.css'
import '@kdocs/kdesign-vue/lib/theme-chalk/index.css'
import '@kdocs/kdesign-icons-vue/styles/index.css' // kdesign图标库的默认样式
import '@/plugins/kdesign-icon'
import '@/assets/scss/index.scss'
import kmtUA from '@kmt/ua'
import KDesignVue from '@kdocs/kdesign-vue'
import i18n from '@/i18n'
import DialogService from '@/components/DialogService'
import { marked } from 'marked'
import '@/styles/markdown.scss'
import '@/plugins/component'
import '@/styles/common.scss'
import Draggable from '@/directives/draggable'
import Multiclick from '@/directives/multiclick'

Vue.use(KDesignVue)
Vue.config.productionTip = false
Vue.use(kmtUA, { isServer: false })
Vue.use(DialogService, { store, i18n })
Vue.prototype.$EventBus = new Vue()
Vue.prototype.$md = marked
Vue.directive('draggable', Draggable)
Vue.directive('multiclick', Multiclick)

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
